import { ElLoading } from 'element-plus';
import { showErrorMessage } from '@/utils/index';
import { longWebURL } from '@/api/index';
export default {
  name: 'WebUrl',
  data() {
    return {
      placeholder: '请输入在线网页链接，点击获取按钮将网页转换成图片或PDF进行下载',
      text: '',
      imageSrc: '',
      processing: false,
      showImg: false,
      radioA: '1',
      quality: 80,
      omitBackground: false,
      downloadTxt: '下载网页长图图片',
      btnGet: '获取网页长图图片',
      isMobile: false
    };
  },
  mounted() {
    // 检测设备类型
    this.checkDeviceType();
    // 监听窗口大小变化
    window.addEventListener('resize', this.checkDeviceType);
  },
  beforeUnmount() {
    // 移除事件监听
    window.removeEventListener('resize', this.checkDeviceType);
  },
  watch: {
    radioA(newv) {
      if (newv === '1') {
        this.downloadTxt = '下载网页长图图片';
        this.btnGet = '获取网页长图图片';
      } else {
        this.downloadTxt = '下载PDF网页';
        this.btnGet = '获取PDF网页';
      }
    }
  },
  methods: {
    // 检测设备类型
    checkDeviceType() {
      this.isMobile = window.innerWidth <= 768;
    },
    clearFn() {
      this.text = '';
      this.imageSrc = '';
      this.processing = false;
      this.showImg = false;
    },
    onInputBlur() {
      if (!this.text) {
        showErrorMessage('链接地址不能为空！');
        return;
      }
      if (!this.text.startsWith('http')) {
        showErrorMessage('请输入有效的链接地址');
        return;
      }
      this.processing = true;
      const loadingInstance = ElLoading.service({
        lock: true,
        text: '网页转换中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const time = Date.now();
      const inputText = this.text;
      longWebURL({
        url: inputText,
        quality: this.quality,
        type: this.radioA,
        omitBackground: this.omitBackground
      }, {
        'x-uid': `${time}-${inputText}`
      }).then(res => {
        if (res?.status === 200 && res?.data?.status === 1) {
          if (this.radioA === '1') {
            this.imageSrc = `data:image/png;base64,${res.data.data}`;
          } else {
            // 使用相对路径
            this.imageSrc = `./dcwytimgapi/${res.data.data}`;
          }
          setTimeout(() => {
            this.showImg = true;
            this.processing = false;
            loadingInstance.close();
          }, 500);
        } else {
          showErrorMessage('网页转换失败！');
          this.processing = false;
          loadingInstance.close();
        }
      }).catch(err => {
        const message = err?.message ?? '操作失败!';
        showErrorMessage(message);
        this.processing = false;
        loadingInstance.close();
      });
    },
    downloadPdf(url) {
      // 创建一个临时的a标签
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = `webpdf_${Date.now()}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    downloadBase64Image(base64String, filename) {
      // 处理base64字符串
      let imageUrl = base64String;
      if (!base64String.startsWith('data:image/')) {
        imageUrl = 'data:image/png;base64,' + base64String;
      }

      // 创建下载链接
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadAll() {
      const time = Date.now();
      if (this.radioA === '2') {
        this.downloadPdf(this.imageSrc);
      } else {
        this.downloadBase64Image(this.imageSrc, `webpage_image_${time}.png`);
      }
    }
  }
};